export default "__VITE_ASSET__DJhGVVMj__"